// src/components/TermsOfServiceModal.jsx
import React, { useState } from "react";
import ModalBackdrop from "components/ModalBackdrop";
import Terms, { TERMS_VERSION } from "./TermsOfService";

export { TERMS_VERSION };

export default function TermsOfServiceModal({ onClose, onAccept, loading }) {
  const [checked, setChecked] = useState(false);

  return (
    <ModalBackdrop>
      <div
        className="w-full max-w-2xl rounded-2xl border border-app bg-app text-app shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-of-service-title"
      >
        <div className="border-b border-app p-5">
          <h2 id="terms-of-service-title" className="text-xl font-semibold text-brand">
            Terms of Service
          </h2>
          <p className="mt-1 text-sm text-muted">
            Please read and accept the Terms of Service before continuing.
          </p>
        </div>

        <div className="max-h-[60vh] overflow-y-auto p-5">
          <Terms />

          <div className="mt-5 border-t border-app pt-4">
            <label className="flex items-start gap-3 text-sm text-app">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                disabled={loading}
                className="mt-1"
              />
              <span>
                I have read, understand, and agree to the Terms of Service.
              </span>
            </label>
          </div>
        </div>

        <div className="flex flex-wrap justify-end gap-3 border-t border-app p-5">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="btn btn-ghost"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onAccept}
            disabled={loading || !checked}
            className="btn btn-primary"
          >
            {loading ? "Saving..." : "I Agree and Continue"}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}
